import { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { IconButtonProps, IconButton as MUIIconButton, SvgIcon, SvgIconProps } from '@mui/material'

type Props = IconButtonProps & {
	fontSize?: string
	icon: IconDefinition
	color?: SvgIconProps['color']
	disabled?: boolean
	loading?: boolean
}

const scale = {
	small: 'scale(0.75)',
	medium: 'scale(1)',
	large: 'scale(1.25)',
}

/**
 * Custom IconButton component that accepts a FontAwesome icon and renders it as an SVG icon.
 * Avoids issue with default MUI IconButton having elliptical shape when using a non-square FontAwesome icon.
 * https://mui.com/material-ui/icons/#font-awesome
 */
function IconButton({
	icon,
	size = 'medium',
	color = 'inherit',
	fontSize = null,
	disabled = false,
	loading = false,
	...props
}: Props) {
	const {
		icon: [width, height, , , svgPathData],
	} = icon
	return (
		<MUIIconButton disabled={disabled} size={size} loading={loading} {...props}>
			<SvgIcon
				sx={{ transform: scale[size], fontSize, visibility: loading ? 'hidden' : null }}
				color={disabled ? 'inherit' : color}
				viewBox={`0 0 ${width} ${height}`}
			>
				{typeof svgPathData === 'string' ? (
					<path d={svgPathData} />
				) : (
					svgPathData.map((d, i) => <path key={d} style={{ opacity: i === 0 ? 0.4 : 1 }} d={d} />)
				)}
			</SvgIcon>
		</MUIIconButton>
	)
}

export default IconButton
